import React from 'react';
import { MainLayout } from '@components';
import MRIsComponents from './MRI';

export default function MRIsPage(props) {
  return <MainLayout footer="main" children={<MRIsComponents {...props} />} />;
}
